import { render, staticRenderFns } from "./health.vue?vue&type=template&id=019ac859&scoped=true&"
import script from "./health.vue?vue&type=script&lang=js&"
export * from "./health.vue?vue&type=script&lang=js&"
import style0 from "./health.vue?vue&type=style&index=0&id=019ac859&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019ac859",
  null
  
)

export default component.exports